import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';
import bus from '../assets/images/bus-and-car-api-integration.jpg';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const BusCar = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	function progressBarScroll() {
		let winScroll =
				document.body.scrollTop || document.documentElement.scrollTop,
			height =
				document.documentElement.scrollHeight -
				document.documentElement.clientHeight,
			scrolled = (winScroll / height) * 100;
		document.getElementById('progressBar').style.width = scrolled + '%';
	}

	window.onscroll = function () {
		progressBarScroll();
	};
	return (
		<div>
			<Navbar />
			<div className='header' style={{ marginTop: 80 }}>
				<div className='progress-container'>
					<div className='progress-bar' id='progressBar'></div>
				</div>
			</div>
			<div
				style={{
					backgroundImage: `url(${bus})`,
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					BUS/CAR API INTEGRATION
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					BUS/CAR API INTEGRATION
				</h6>
			</div>
			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					"Providing a Strong Foundation for Strong Advisories"
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={12}>
							<p>
								Arya Aviation provides Bus/Car APIs for the easy bus/car
								bookings. This portal will also offer bus & car rentals advance
								bookings to those travelers who plan their trip to visit ‘n’
								number of destinations.
							</p>
							<br />
							<p>
								Each rental Bus/CAR APIs has a great rate and provides a variety
								of pick-up and drop-off options. Our Bus/Car APIs provide a
								powerful booking platform, enabling travelers to book for rental
								cars and buses to complete reservations online from anywhere.
							</p>
							<br />
							<p>
								Arya Aviation Bus/Car APIs allows the customers to book vehicles
								through Travel Portal Solution where a customer can search which
								gives complete control over the admin area where all the details
								showing.
							</p>
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>
			<div style={{ padding: 10 }}>
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/bbb.png' />
						</Grid>
						<Grid item xs={8}>
							<p>
								Arya Aviation Hotel API provides comprehensive descriptions
								including room types, images, and facilities, of over 7,00,000+
								properties worldwide. As one of the trusted API providers
								worldwide, our team is specialized in Hotel API Integrations and
								Hotel Booking website Development. All our services are
								integrated, tested and maintained by our experienced team of
								professionals. Arya Aviation Team have a great experience in API
								integration and Travel technology. We have ready-made solution
								for major Hotel API suppliers. We provide hotel booking system
								for Travel Agencies or DMCs who have their business in B2B as
								well as in B2C market. We also provide ready-made or white label
								travel solution for Hotel Booking Services having inbuilt Hotel
								API Integration, allowing you to use real-time fares and
								availability, amenities, and all other important information, as
								well as the range of suitability of hotel rooms. API Integration
								provides a better way to develop your hotel booking platform
								using content from multiple supplier sources that can accurately
								match your customers.
							</p>
						</Grid>
					</Grid>
				</Container>
			</div>

			<Container style={{ marginTop: 10 }}>
				<p>
					Arya Aviation provides a wide variety of portals like B2C Travel
					Portal, B2B Travel Portal, B2B2B Travel Portal, B2E Travel Portal etc.
					and Travel APIs to modify your Travel Business Model. You can enhance
					your revenue by providing a wide range of global hotel content and
					best contract deals benefit from the integration of the best hotel
					APIs to your users.
				</p>
				<br />
				<p>
					Arya Aviation Provides seamless integration of Hotel API for all these
					features through integration of XML/JSON APIs for B2C and B2B travel
					portal modules. Our advance and technically strong Hotel API
					Integration solution provides opportunity to grow your business and
					increase number of bookings without hassles. By using Hotel API
					Integration Solution and Arya Aviation most trusted and flexible
					Travel Portal Solution you can achieve your target in travel industry
					in short time of period.
				</p>
				<br />
				<p>
					Hotel API Integration make the work easy, easy to maintain, real time,
					less man power required to take requirements from customer and do
					offline confirmation from hoteliers. Less man power means running cost
					is less so you can save your money. In modern times Travel Agencies
					have limited time for the remarkable work and API makes these tasks
					easy. So the integration of API with your business will be a better
					decision. A wide array of Hotel choices in every location, each
					providing different prices and availability, the task of navigating
					through multiple Hotel suppliers can be made easy with Hotel API
					Integration. The Online Hotel Booking System allows every customer to
					get access to large hotel inventory from anywhere in the world.
				</p>
				<br />
			</Container>
			<Divider />
			<div style={{ background: '#0a74c0', padding: 13 }}>
				<Container>
					<p style={{ color: 'white', fontSize: 14 }}>
						How does API Integration help to improve the growth of your
						business?
					</p>
				</Container>
			</div>
			<Footer />
		</div>
	);
};

export default BusCar;
